import { render } from "./EditingUsersHeader.vue?vue&type=template&id=763f0fa3"
import script from "./EditingUsersHeader.vue?vue&type=script&lang=js"
export * from "./EditingUsersHeader.vue?vue&type=script&lang=js"

import "./EditingUsersHeader.vue?vue&type=style&index=0&id=763f0fa3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__